module.exports = __webpack_public_path__ + "img/tour-43.70409a70.png";